import { formatDate } from "../formating";
import { normalizePhone, normalizeString } from "../functions";

const customerSchema = {
  email: (email) => normalizeString({ data: email, actions: ["spacing"] }),
  firstName: (firstName) =>
    normalizeString({ data: firstName, actions: ["spacing"] }),
  lastName: (lastName) =>
    normalizeString({ data: lastName, actions: ["spacing"] }),
  phone: (phone) => normalizePhone(phone),
  city: (city) => normalizeString({ data: city, actions: ["spacing"] }),
  state: (state) => normalizeString({ data: state, actions: ["spacing"] }),
  zip: (zip) => zip,
  country: (country) => "US",
  addressLine1: (addressLine1) =>
    normalizeString({ data: addressLine1, actions: ["spacing"] }),
  addressLine2: (addressLine2) =>
    normalizeString({ data: addressLine2, actions: ["spacing"] }),
  dateOfBirth: (dob) =>
    formatDate({
      actions: ["mysql"],
      data: dob,
    }),
  socialSecurityNumber: (socialSecurityNumber) => {
    const formatted = socialSecurityNumber.replace(/-/g, "");
    return formatted;
  },
  mode: () => "partner",
  isOneClick: (isOneClick) => isOneClick,
  checkoutSessionId: (checkoutSessionId) => checkoutSessionId,
  taxFilingStatus: (taxFilingStatus) => taxFilingStatus,
};

export default customerSchema;
